// import { LocationShow } from './LocationShow'
// import { LocationList } from './LocationList'
import { MerchantList } from './MerchantList'

export const merchant = {
  list: MerchantList,
}
